// src/directives/theme.js
export default {
    bind(el, binding, vnode) {
        const { $store, hover } = binding.modifiers;
        let colorConfig = binding.value;
        let color;
        let backgroundColor;
        let borderColor;

        // 处理不同格式的颜色配置
        if ($store && vnode.context.$store) {
            // 如果是对象格式 { color: 'red' }
            if (typeof colorConfig === 'object' && colorConfig !== null) {
                color = colorConfig.color;
                backgroundColor = colorConfig.backgroundColor;
                borderColor = colorConfig.borderColor;
            }
            // 如果是字符串格式
            else if (typeof colorConfig === 'string') {
                const themeColors = vnode.context.$store.state.template?.globalStyle || {};
                color = themeColors[colorConfig];
                backgroundColor = themeColors[colorConfig];
                borderColor = themeColors[colorConfig];
            }
        } else {
            // 直接使用传入的颜色值
            if (typeof colorConfig === 'object' && colorConfig !== null) {
                color = colorConfig.color;
                backgroundColor = colorConfig.backgroundColor;
                borderColor = colorConfig.borderColor;
            } else {
                color = colorConfig;
                backgroundColor = colorConfig;
                borderColor = colorConfig;
            }
        }

        // 修改1: 移除仅检查color的限制，改为检查是否有任何属性
        if (!color && !backgroundColor && !borderColor) return;

        // 基础样式设置 - 修改2: 添加所有属性的过渡效果
        el.style.transition = 'all 0.3s';

        // hover效果
        if (hover) {
            // 保存原始样式
            const originalStyles = {
                color: getComputedStyle(el).color,
                backgroundColor: getComputedStyle(el).backgroundColor,
                borderColor: getComputedStyle(el).borderColor
            };

            el.addEventListener('mouseenter', () => {
                // 修改3: 正确使用各属性变量
                if (color !== undefined) el.style.color = color;
                if (backgroundColor !== undefined) el.style.backgroundColor = backgroundColor;
                if (borderColor !== undefined) el.style.borderColor = borderColor;
            });

            el.addEventListener('mouseleave', () => {
                // 修改4: 正确恢复各属性原始值
                if (color !== undefined) el.style.color = originalStyles.color;
                if (backgroundColor !== undefined) el.style.backgroundColor = originalStyles.backgroundColor;
                if (borderColor !== undefined) el.style.borderColor = originalStyles.borderColor;
            });
        } else {
            // 直接应用颜色
            if (color !== undefined) el.style.color = color;
            if (backgroundColor !== undefined) el.style.backgroundColor = backgroundColor;
            if (borderColor !== undefined) el.style.borderColor = borderColor;
        }
    }
}
